import { z } from 'zod';

export const getDocumentStatusesSchema = z.array(
  z.object({
    id: z.string(),
    code: z.string().optional(),
    name: z.string().optional(),
    status: z.number(),
    statusString: z.string().optional(),
    isFromManager: z.boolean(),
    isActive: z.boolean().optional(),
  })
);

export type GetDocumentStatusesResponse = z.infer<typeof getDocumentStatusesSchema>;
